module.exports = __webpack_public_path__ + "img/5868bbd37b7e4031b28b6a1fdbc52640-640.2f3590e9.jpg";